import { Nullish } from 'shared/utils/type-utils';
import { ProductCarouselProps } from 'src/components/product-carousel';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { useCollections, CollectionDisplayMode } from 'src/dispensary/collections/use-collections';

type UseCollectionCarouselParams = {
  collectionId: string;
  sortBy: string;
};

type UseCollectionCarouselReturn = Omit<ProductCarouselProps, 'heading'> & {
  cardBadgeColor: Nullish | string;
  collectionDisplayMode: CollectionDisplayMode;
};

export function useCollectionCarousel({
  collectionId,
  sortBy,
}: UseCollectionCarouselParams): UseCollectionCarouselReturn {
  const { dispensary } = useDispensary();

  const { collection, loading, collectionDisplayMode } = useCollections({
    collectionId,
    dispensaryId: dispensary?.id ?? '',
    limit: 25,
    sortBy,
    skipCollectionQuery: !collectionId || !dispensary?.id,
  });

  return {
    products: collection?.products ?? [],
    loading,
    cardBadgeColor: collection?.cardBadgeColor,
    collectionDisplayMode,
  };
}
